import { Tooltip } from '@/components/ui/tooltip';
import { cn } from '@/lib/cn';
import { SIDEBAR_SHORTCUT_LABEL } from '@/lib/platform';
import { useIsMobile } from '@/lib/useIsMobile';
import { useSidebarCollapsed } from '@/lib/useSidebarCollapsed';
import { PanelLeftOpen } from 'lucide-react';

interface Props {
  /** 외부에서 위치/크기 보정용. */
  className?: string;
}

/**
 * 사이드바 열기 햄버거 버튼.
 *
 * - 데스크탑 + 사이드바 펼친 상태 (`!collapsed && !isMobile`) → 렌더 안 함.
 * - 그 외 (사이드바 접힘 또는 모바일) → 햄버거 버튼 노출, click 시 `open()`.
 *
 * 사용 위치:
 * - chat 헤더 좌측 첫 자식 (인라인)
 * - chat Index hero 위 (absolute)
 * - wiki/admin layout 의 mobile top bar
 */
export function SidebarOpenerButton({ className }: Props) {
  const { collapsed, open } = useSidebarCollapsed();
  const isMobile = useIsMobile();

  // 데스크탑 + 사이드바 펼침 → 안 보여줌.
  if (!isMobile && !collapsed) return null;

  return (
    <Tooltip label="사이드바 열기" shortcut={SIDEBAR_SHORTCUT_LABEL} side="bottom">
      <button
        type="button"
        onClick={open}
        aria-label="사이드바 열기"
        className={cn(
          'size-8 grid place-items-center rounded-md border border-border bg-background text-foreground-muted hover:bg-surface-muted hover:text-foreground transition-colors shrink-0',
          className,
        )}
      >
        <PanelLeftOpen className="size-4" />
      </button>
    </Tooltip>
  );
}
